<div #top></div>
<h1 *ngIf="pageTitle" class="is-vishidden" data-testid="page-title">{{ pageTitle }}</h1>
<form
  *ngIf="formStatus !== FormStatus.COMPLETE"
  class="mr-large-t"
  [name]="GIFT_CARD_FORM_NAME"
  (submit)="nextStep($event)"
>
  <div class="previous-step ps-large-b" *ngIf="formStep !== FormStep.GIFT_CARD_VERIFICATION">
    <button
      class="back-button flex no-decoration nordic-blue-900-text regular-type font-body-1 link-hover"
      data-testid="back-button"
      type="button"
      (click)="previousStep()"
    >
      <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_LEFT"></fcom-icon>
      {{ 'SERVICE_FORMS.CSServiceForms.wizard.back' | finLocalization }}
    </button>
  </div>

  <fieldset class="border-none ps-clear" [disabled]="formIsDisabled" [ngSwitch]="formStep">
    <ng-container *ngSwitchCase="FormStep.GIFT_CARD_VERIFICATION">
      <legend class="font-heading-1 nordic-blue-900-text">
        {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardVerification.title' | finLocalization }}
      </legend>
      <div class="mr-medium-t pr-medium border rounded-large nordic-blue-100-border">
        <div class="grid grid-col-12 grid-max-width no-gutters">
          <fcom-text-input
            class="col-1-12 sm-col-1-6"
            data-testid="gift-card-id"
            [ariaOptions]="{ details: 'gift-card-verification-footnotes' }"
            [controlName]="FormControlName.GIFT_CARD_ID"
            [disableAutoComplete]="true"
            [displayMargin]="false"
            [parentForm]="verificationForm"
            [placeHolder]="'SERVICE_FORMS.serviceForms.giftCardInformationForm.fields.giftCardId.placeholder'"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.giftCardInformationForm.fields.giftCardId'"
          ></fcom-text-input>
          <fcom-text-input
            class="col-1-12 sm-col-7-12"
            data-testid="gift-card-pin"
            [ariaOptions]="{ details: 'gift-card-verification-footnotes' }"
            [controlName]="FormControlName.GIFT_CARD_PIN_1"
            [disableAutoComplete]="true"
            [displayMargin]="false"
            [parentForm]="verificationForm"
            [placeHolder]="'SERVICE_FORMS.serviceForms.giftCardInformationForm.fields.giftCardPin.placeholder'"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.giftCardInformationForm.fields.giftCardPin'"
          ></fcom-text-input>
        </div>
        <fcom-notification
          *ngIf="errorStatus && FormStatus.ERROR === formStatus"
          aria-live="polite"
          class="mr-small-t"
          data-testid="gift-card-verification-error"
          id="gift-card-verification-notification"
          [layout]="NotificationLayout.BLOCK"
          [theme]="NotificationTheme.ALERT"
        >
          <ng-container [ngSwitch]="errorStatus">
            <ng-container *ngSwitchCase="400">
              {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.error.notFound' | finLocalization }}
            </ng-container>
            <ng-container *ngSwitchCase="404">
              {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.error.notFound' | finLocalization }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.error.requestError' | finLocalization }}
            </ng-container>
          </ng-container>
        </fcom-notification>
        <div id="gift-card-verification-footnotes" class="footnotes">
          <p
            *ngFor="
              let footnote of 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardVerification.footnotes'
                | finLocalization
            "
            class="regular-type ps-large-y"
            [innerHTML]="footnote | finSafe: 'html'"
          ></p>
        </div>
      </div>
      <div class="controls mr-medium-y">
        <fcom-button
          class="ms-small-l continue"
          data-testid="continue-button"
          [aria]="{ describedby: FormStatus.ERROR === formStatus ? 'gift-card-verification-notification' : undefined }"
          [disabled]="formIsDisabled"
          [text]="'SERVICE_FORMS.serviceForms.continue' | finLocalization"
          [type]="ButtonType.SUBMIT"
        ></fcom-button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="FormStep.GIFT_CARD_INFORMATION">
      <legend class="font-heading-1 nordic-blue-900-text">
        {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardInformation.title' | finLocalization }}
      </legend>
      <div
        id="gift-card-information-details"
        class="mr-large-y ps-large ps-xxlarge-b border rounded-large nordic-blue-100-border"
      >
        <dl class="available-value">
          <dt class="font-body-1 bold-type label nowrap" data-testid="available-value-label">
            {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.labels.availableValue' | finLocalization }}
          </dt>
          <dd class="value font-body-1 align-right" data-testid="available-value">
            {{
              {
                amount: giftCardData.availableValue,
                currencyCode: giftCardData.currency,
              } | finPrice: { stripZeroCents: true }
            }}
          </dd>
          <dd
            *ngIf="GiftCardStatus.CONVERTED === giftCardData.status"
            class="error-900-text font-body-1 error-message"
            data-testid="message-converted"
          >
            {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.error.converted' | finLocalization }}
          </dd>
        </dl>
        <dl
          *ngIf="giftCardIsConvertible || GiftCardStatus.CONVERTED === giftCardData.status"
          class="flex flex--space-between ms-medium-y"
          data-testid="cash-amount"
        >
          <dt class="font-body-1 bold-type" data-testid="cash-value-label">
            {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.labels.cashValue' | finLocalization }}
          </dt>
          <dd class="font-body-1 nowrap" data-testid="cash-value">
            {{
              {
                amount: giftCardData.cashValue,
                currencyCode: giftCardData.currency,
              } | finPrice: { stripZeroCents: true }
            }}
          </dd>
        </dl>
        <dl class="flex flex--space-between ms-medium-y">
          <dt class="font-body-1 bold-type" data-testid="gift-card-id-label">
            {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.fields.giftCardId.label' | finLocalization }}
          </dt>
          <dd class="font-body-1 align-right" data-testid="gift-card-id">
            {{ giftCardData.giftCardId | finFormatCardNumber }}
          </dd>
        </dl>
        <dl class="flex flex--space-between ms-medium-y">
          <dt class="font-body-1 bold-type flex--basis-full" data-testid="expires-on-label">
            {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.labels.expiresOn' | finLocalization }}
          </dt>
          <dd class="align-right font-body-1 text nowrap" data-testid="expires-on-date">
            <time [dateTime]="giftCardData.expiryDate"
              >{{ giftCardData.expiryDate | finDateFormat: 'DATE' }} {{ giftCardData.expiryDate | finTime }}</time
            >
            <div
              *ngIf="GiftCardStatus.EXPIRED === giftCardData.status"
              class="error-900-text font-body-1"
              data-testid="message-expired"
            >
              {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.error.expired' | finLocalization }}
            </div>
          </dd>
        </dl>
        <div class="footnotes">
          <p
            *ngIf="GiftCardStatus.CANCELLED === giftCardData.status"
            class="error-900-text font-body-1"
            data-testid="message-cancelled"
          >
            {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.error.cancelled' | finLocalization }}
          </p>
          <p
            *ngIf="GiftCardStatus.LOCKED === giftCardData.status"
            class="error-900-text font-body-1"
            data-testid="message-locked"
          >
            {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.error.locked' | finLocalization }}
          </p>
          <p
            *ngFor="
              let footnote of 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardInformation.footnotes'
                | finLocalization
            "
            [innerHTML]="footnote | finSafe: 'html'"
          ></p>
        </div>
      </div>
      <div *ngIf="giftCardData.status !== GiftCardStatus.INITIAL" class="mr-large-b">
        <h2>
          {{
            'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardInformation.importantNotes.title'
              | finLocalization
          }}
        </h2>
        <ng-container *ngIf="GiftCardStatus.ACTIVE === giftCardData.status && giftCardData.isConvertibleToCash">
          <ng-container
            *ngFor="
              let terms of 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardInformation.importantNotes.termsAndConditions.activeConvertible'
                | finLocalization;
              let i = index
            "
          >
            <h3 class="font-body-1 bold-type mr-xsmall-b" [class]="i === 0 ? 'mr-xlarge-t' : 'mr-medium-t'">
              {{ terms.title }}
            </h3>
            <ul class="mr-medium-l mr-xsmall-t">
              <li *ngFor="let condition of terms.conditions" [innerHTML]="condition | finSafe: 'html'"></li>
            </ul>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="GiftCardStatus.ACTIVE === giftCardData.status && !giftCardData.isConvertibleToCash">
          <ng-container
            *ngFor="
              let terms of 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardInformation.importantNotes.termsAndConditions.activeNonConvertible'
                | finLocalization;
              let i = index
            "
          >
            <h3 class="font-body-1 bold-type mr-xsmall-b" [class]="i === 0 ? 'mr-xlarge-t' : 'mr-medium-t'">
              {{ terms.title }}
            </h3>
            <ul class="mr-medium-l mr-xsmall-t">
              <li *ngFor="let condition of terms.conditions" [innerHTML]="condition | finSafe: 'html'"></li>
            </ul>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="GiftCardStatus.EXPIRED === giftCardData.status">
          <ng-container
            *ngFor="
              let terms of 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardInformation.importantNotes.termsAndConditions.expired'
                | finLocalization
            "
          >
            <h3 class="font-body-1 bold-type mr-xsmall-b mr-large-t">{{ terms.title }}</h3>
            <ul class="terms-and-conditions mr-medium-l mr-xsmall-t">
              <li *ngFor="let condition of terms.conditions" [innerHTML]="condition | finSafe: 'html'"></li>
            </ul>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="GiftCardStatus.LOCKED === giftCardData.status">
          <ng-container
            *ngFor="
              let terms of 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardInformation.importantNotes.termsAndConditions.locked'
                | finLocalization;
              let i = index
            "
          >
            <h3 class="font-body-1 bold-type mr-xsmall-b" [class]="i === 0 ? 'mr-xlarge-t' : 'mr-medium-t'">
              {{ terms.title }}
            </h3>
            <ul class="mr-medium-l mr-xsmall-t">
              <li *ngFor="let condition of terms.conditions" [innerHTML]="condition | finSafe: 'html'"></li>
            </ul>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="GiftCardStatus.CONVERTED === giftCardData.status">
          <ng-container
            *ngFor="
              let terms of 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardInformation.importantNotes.termsAndConditions.converted'
                | finLocalization;
              let i = index
            "
          >
            <h3 class="font-body-1 bold-type mr-xsmall-b" [class]="i === 0 ? 'mr-xlarge-t' : 'mr-medium-t'">
              {{ terms.title }}
            </h3>
            <ul class="mr-medium-l mr-xsmall-t">
              <li *ngFor="let condition of terms.conditions" [innerHTML]="condition | finSafe: 'html'"></li>
            </ul>
          </ng-container>
        </ng-container>
      </div>
      <div class="controls mr-medium-y">
        <fcom-button
          data-testid="previous-step"
          (clickBtn)="previousStep()"
          [text]="'SERVICE_FORMS.serviceForms.back' | finLocalization"
        ></fcom-button>
        <fcom-button
          *ngIf="giftCardIsConvertible"
          class="ms-small-l"
          data-testid="continue-button"
          [aria]="{ describedby: !currentStepIsValid ? 'gift-card-information-details' : undefined }"
          [disabled]="formIsDisabled"
          [text]="'SERVICE_FORMS.serviceForms.giftCardInformationForm.labels.convertToCash' | finLocalization"
          [type]="ButtonType.SUBMIT"
        ></fcom-button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="FormStep.BANK_DETAILS">
      <legend class="font-heading-1 nordic-blue-900-text">
        {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.bankDetails.title' | finLocalization }}
      </legend>
      <p class="font-body-2" [innerHTML]="bankDetailsDescription | finLocalization | finSafe: 'html'"></p>
      <div class="mr-large-y bank-details flex flex--wrap pr-medium border rounded-large nordic-blue-100-border">
        <fin-select-input
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-bank-country"
          [controlName]="PaymentDetailsInputs.BANK_COUNTRY"
          [displayMargin]="false"
          [options]="countries"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bankCountry'"
        ></fin-select-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.IBAN).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-iban"
          [controlName]="PaymentDetailsInputs.IBAN"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.iban'"
          (change)="stripInputSpaces(bankDetailsForm, PaymentDetailsInputs.IBAN)"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.ACCOUNT_NUMBER).enabled"
          class="bank-details-account-number bank-details-input fill pr-small-b"
          data-testid="wizard-payment-account-number"
          [controlName]="PaymentDetailsInputs.ACCOUNT_NUMBER"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="
            RefundFormCountries.INDIA === bankDetailsForm.get(PaymentDetailsInputs.BANK_COUNTRY)?.value
              ? 'SERVICE_FORMS.serviceForms.fields.indianAccountNumber'
              : 'SERVICE_FORMS.serviceForms.fields.accountNumber'
          "
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.ACCOUNT_HOLDER).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-account-holder"
          [controlName]="PaymentDetailsInputs.ACCOUNT_HOLDER"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.CSServiceForms.wizard.steps.paymentDetails.accountHolder'"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.ACCOUNT_HOLDER_ADDRESS).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-account-holder-address"
          [controlName]="PaymentDetailsInputs.ACCOUNT_HOLDER_ADDRESS"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.accountHolderAddress'"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.BIC).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-bic"
          [controlName]="PaymentDetailsInputs.BIC"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bic'"
          (change)="stripInputSpaces(bankDetailsForm, PaymentDetailsInputs.BIC)"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.BANK_NAME).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-bank-name"
          [controlName]="PaymentDetailsInputs.BANK_NAME"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bankPlainName'"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.BANK_ADDRESS).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-bank-address"
          [controlName]="PaymentDetailsInputs.BANK_ADDRESS"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bankAddress'"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.NCC).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-ncc"
          [controlName]="PaymentDetailsInputs.NCC"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.ncc'"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.IFSC).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-ifsc"
          [controlName]="PaymentDetailsInputs.IFSC"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.ifsc'"
          (change)="stripInputSpaces(bankDetailsForm, PaymentDetailsInputs.IFSC)"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.BIK).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-bik"
          [controlName]="PaymentDetailsInputs.BIK"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bik'"
          (change)="stripInputSpaces(bankDetailsForm, PaymentDetailsInputs.BIK)"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.CBD).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-cbd"
          [controlName]="PaymentDetailsInputs.CBD"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.correspondentBankData'"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.KPP).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-kpp"
          [controlName]="PaymentDetailsInputs.KPP"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.kpp'"
          (change)="stripInputSpaces(bankDetailsForm, PaymentDetailsInputs.KPP)"
        ></fcom-text-input>
        <fcom-text-input
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-inn"
          [controlName]="PaymentDetailsInputs.INN"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.inn'"
          (change)="stripInputSpaces(bankDetailsForm, PaymentDetailsInputs.INN)"
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.INN).enabled"
        ></fcom-text-input>
        <fcom-text-input
          *ngIf="bankDetailsForm.get(PaymentDetailsInputs.PATRONYMIC_NAME).enabled"
          class="bank-details-input fill pr-small-b"
          data-testid="wizard-payment-patronymic-name"
          [controlName]="PaymentDetailsInputs.PATRONYMIC_NAME"
          [displayMargin]="false"
          [parentForm]="bankDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.patronymicName'"
        ></fcom-text-input>
      </div>
      <div class="controls mr-medium-y">
        <fcom-button
          (clickBtn)="previousStep()"
          [text]="'SERVICE_FORMS.serviceForms.back' | finLocalization"
        ></fcom-button>
        <fcom-button
          class="ms-small-l continue"
          data-testid="continue-button"
          [disabled]="formIsDisabled"
          [text]="'SERVICE_FORMS.serviceForms.continue' | finLocalization"
          [type]="ButtonType.SUBMIT"
        ></fcom-button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="FormStep.CONTACT_DETAILS">
      <legend class="font-heading-1 nordic-blue-900-text">
        {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.customerDetails.title' | finLocalization }}
      </legend>
      <p
        [innerHTML]="
          'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.customerDetails.description'
            | finLocalization
            | finSafe: 'html'
        "
      ></p>
      <div class="mr-large-y pr-medium border rounded-large nordic-blue-100-border">
        <fcom-text-input
          [controlName]="FormControlName.EMAIL_ADDRESS"
          [parentForm]="contactDetailsForm"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.email'"
        ></fcom-text-input>
      </div>
      <div class="controls mr-medium-y">
        <fcom-button
          (clickBtn)="previousStep()"
          [text]="'SERVICE_FORMS.serviceForms.back' | finLocalization"
        ></fcom-button>
        <fcom-button
          class="ms-small-l continue"
          data-testid="continue-button"
          [disabled]="formIsDisabled"
          [text]="'SERVICE_FORMS.serviceForms.continue' | finLocalization"
          [type]="ButtonType.SUBMIT"
        ></fcom-button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="FormStep.GIFT_CARD_CONVERSION">
      <legend class="font-heading-1 nordic-blue-900-text" data-testid="conversion-title">
        {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardConversion.title' | finLocalization }}
      </legend>
      <p
        [innerHTML]="
          'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardConversion.description'
            | finLocalization
            | finSafe: 'html'
        "
      ></p>
      <div class="mr-large-y pr-medium border rounded-large nordic-blue-100-border">
        <fcom-notification
          *ngIf="FormStatus.ERROR === formStatus && errorStatus"
          aria-live="polite"
          class="mr-small-b"
          data-testid="gift-card-conversion-error"
          id="gift-card-conversion-notification"
          [layout]="NotificationLayout.BLOCK"
          [theme]="NotificationTheme.ALERT"
        >
          <ng-container [ngSwitch]="errorStatus">
            <ng-container *ngSwitchCase="400">
              {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.error.notFound' | finLocalization }}
            </ng-container>
            <ng-container *ngSwitchCase="404">
              {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.error.notFound' | finLocalization }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.error.requestError' | finLocalization }}
            </ng-container>
          </ng-container>
        </fcom-notification>
        <table id="gift-card-conversion-table" class="conversion-table table fill font-body-1">
          <caption
            class="align-left font-body-1 mr-small-b"
            [innerHTML]="
              'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardConversion.formDescription'
                | finLocalization
                | finSafe: 'html'
            "
          ></caption>
          <tbody>
            <tr>
              <th class="align-left block full-width" data-testid="available-value-label">
                {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.labels.giftCardValue' | finLocalization }}
              </th>
              <td class="align-left block full-width pr-small-b" data-testid="available-value">
                {{
                  {
                    amount: giftCardData.availableValue,
                    currencyCode: giftCardData.currency,
                  } | finPrice: { stripZeroCents: true }
                }}
              </td>
            </tr>
            <tr>
              <th class="align-left block full-width" data-testid="cash-value-label">
                {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.labels.cashValue' | finLocalization }}
              </th>
              <td class="align-left block full-width bold-type pr-small-b" data-testid="cash-value">
                {{
                  {
                    amount: giftCardData.cashValue,
                    currencyCode: giftCardData.currency,
                  } | finPrice: { stripZeroCents: true }
                }}
              </td>
            </tr>
            <tr>
              <th id="gift-card-conversion-table-bank-details-label" class="align-left block">
                {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.bankDetails.label' | finLocalization }}
              </th>
              <td class="align-left block full-width pr-small-b">
                <dl aria-describedby="gift-card-conversion-table-bank-details-label">
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.ACCOUNT_HOLDER]">
                    <dt class="is-vishidden" data-testid="account-holder-label">
                      {{ 'SERVICE_FORMS.serviceForms.fields.accountHolder.label' | finLocalization }}
                    </dt>
                    <dd class="bold-type" data-testid="account-holder">
                      {{ bankDetailsForm.value[PaymentDetailsInputs.ACCOUNT_HOLDER] }}
                    </dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.ACCOUNT_HOLDER_ADDRESS]">
                    <dt class="is-vishidden">
                      {{ 'SERVICE_FORMS.serviceForms.fields.accountHolderAddress.label' | finLocalization }}
                    </dt>
                    <dd>
                      {{ bankDetailsForm.value[PaymentDetailsInputs.ACCOUNT_HOLDER_ADDRESS] }}
                    </dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.ACCOUNT_NUMBER]">
                    <dt class="is-vishidden" data-testid="account-number-label">
                      {{
                        RefundFormCountries.INDIA === bankDetailsForm.get(PaymentDetailsInputs.BANK_COUNTRY)?.value
                          ? 'SERVICE_FORMS.serviceForms.fields.indianAccountNumber.label'
                          : ('SERVICE_FORMS.serviceForms.fields.accountNumber.label' | finLocalization)
                      }}
                    </dt>
                    <dd class="bold-type" data-testid="account-number">
                      {{ bankDetailsForm.value[PaymentDetailsInputs.ACCOUNT_NUMBER] }}
                    </dd>
                  </ng-container>
                  <ng-container
                    *ngIf="bankDetailsForm.value[PaymentDetailsInputs.IBAN]"
                    data-testid="account-number-label"
                  >
                    <dt class="is-vishidden">{{ 'SERVICE_FORMS.serviceForms.fields.iban.label' | finLocalization }}</dt>
                    <dd
                      [title]="'SERVICE_FORMS.serviceForms.fields.iban.label' | finLocalization"
                      data-testid="account-number"
                    >
                      {{ bankDetailsForm.value[PaymentDetailsInputs.IBAN] }}
                    </dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.BIC]">
                    <dt class="is-vishidden">{{ 'SERVICE_FORMS.serviceForms.fields.bic.label' | finLocalization }}</dt>
                    <dd>{{ bankDetailsForm.value[PaymentDetailsInputs.BIC] }}</dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.BIK]">
                    <dt class="is-vishidden">{{ 'SERVICE_FORMS.serviceForms.fields.bik.label' | finLocalization }}</dt>
                    <dd>{{ bankDetailsForm.value[PaymentDetailsInputs.BIK] }}</dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.IFSC]">
                    <dt class="is-vishidden">{{ 'SERVICE_FORMS.serviceForms.fields.ifsc.label' | finLocalization }}</dt>
                    <dd>{{ bankDetailsForm.value[PaymentDetailsInputs.IFSC] }}</dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.INN]">
                    <dt class="is-vishidden">{{ 'SERVICE_FORMS.serviceForms.fields.inn.label' | finLocalization }}</dt>
                    <dd>{{ bankDetailsForm.value[PaymentDetailsInputs.INN] }}</dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.KPP]">
                    <dt class="is-vishidden">{{ 'SERVICE_FORMS.serviceForms.fields.kpp.label' | finLocalization }}</dt>
                    <dd>{{ bankDetailsForm.value[PaymentDetailsInputs.KPP] }}</dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.NCC]">
                    <dt class="is-vishidden">{{ 'SERVICE_FORMS.serviceForms.fields.ncc.label' | finLocalization }}</dt>
                    <dd>{{ bankDetailsForm.value[PaymentDetailsInputs.NCC] }}</dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.PATRONYMIC_NAME]">
                    <dt class="is-vishidden">
                      {{ 'SERVICE_FORMS.serviceForms.fields.patronymicName.label' | finLocalization }}
                    </dt>
                    <dd>{{ bankDetailsForm.value[PaymentDetailsInputs.PATRONYMIC_NAME] }}</dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.BANK_NAME]">
                    <dt class="is-vishidden">
                      {{ 'SERVICE_FORMS.serviceForms.fields.bankPlainName.label' | finLocalization }}
                    </dt>
                    <dd>{{ bankDetailsForm.value[PaymentDetailsInputs.BANK_NAME] }}</dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.BANK_ADDRESS]">
                    <dt class="is-vishidden">
                      {{ 'SERVICE_FORMS.serviceForms.fields.bankAddress.label' | finLocalization }}
                    </dt>
                    <dd>{{ bankDetailsForm.value[PaymentDetailsInputs.BANK_ADDRESS] }}</dd>
                  </ng-container>
                  <ng-container *ngIf="bankDetailsForm.value[PaymentDetailsInputs.BANK_COUNTRY]">
                    <dt class="is-vishidden" data-testid="bank-country-label">
                      {{ 'SERVICE_FORMS.serviceForms.fields.bankCountry.label' | finLocalization }}
                    </dt>
                    <dd data-testid="bank-country">{{ bankCountry?.name }}</dd>
                  </ng-container>
                </dl>
              </td>
            </tr>
            <tr>
              <th class="align-left block full-width">
                {{ 'SERVICE_FORMS.serviceForms.fields.email.label' | finLocalization }}
              </th>
              <td class="align-left block full-width pr-small-b">{{ contactDetailsForm.get('emailAddress').value }}</td>
            </tr>
          </tbody>
        </table>
        <div class="form-subgroup mr-medium-b mr-medium-t">
          <p class="font-body-1">
            {{
              'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardConversion.confirmationLabel'
                | finLocalization
            }}
          </p>
          <p class="grid-col-12 grid-max-width no-gutters unstyled">
            <fcom-text-input
              class="col-1-5"
              data-testid="gift-card-pin"
              [controlName]="FormControlName.GIFT_CARD_PIN_2"
              [disableAutoComplete]="true"
              [displayMargin]="false"
              [parentForm]="conversionForm"
              [placeHolder]="'SERVICE_FORMS.serviceForms.giftCardInformationForm.fields.giftCardPin.placeholder'"
              [translationPrefix]="'SERVICE_FORMS.serviceForms.giftCardInformationForm.fields.giftCardPin'"
            ></fcom-text-input>
          </p>
        </div>
      </div>
      <div
        class="footnotes"
        data-testid="gift-card-conversion-footnotes"
        *ngIf="
          'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardConversion.footnotes' | finLocalization
        "
      >
        <div
          *ngFor="
            let footnote of 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardConversion.footnotes'
              | finLocalization
          "
          [outerHTML]="footnote | resolveLinks | finSafe: 'html'"
        ></div>
      </div>
      <div class="controls mr-medium-y">
        <fcom-button
          (clickBtn)="previousStep()"
          [text]="'SERVICE_FORMS.serviceForms.back' | finLocalization"
        ></fcom-button>
        <fcom-button
          class="ms-small-l"
          data-testid="submit-form"
          [aria]="{ describedby: FormStatus.ERROR === formStatus ? 'gift-card-conversion-notification' : undefined }"
          [disabled]="formIsDisabled"
          [text]="'SERVICE_FORMS.serviceForms.submit' | finLocalization"
          [type]="ButtonType.SUBMIT"
        ></fcom-button>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault></ng-container>
  </fieldset>
</form>

<article *ngIf="FormStatus.COMPLETE === formStatus" class="align-center mr-xxlarge-y" data-testid="success-container">
  <fcom-icon class="icon-xxlarge mr-medium-b" [name]="SvgLibraryIcon.CHECKMARK_BLOCK"></fcom-icon>
  <h2 class="font-heading-1" data-testid="success-title">
    {{ 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardConversionComplete.title' | finLocalization }}
  </h2>
  <p
    *ngFor="
      let footnote of 'SERVICE_FORMS.serviceForms.giftCardInformationForm.steps.giftCardConversionComplete.footnotes'
        | finLocalization
    "
    [innerHTML]="footnote | finSafe: 'html'"
  ></p>
</article>
